import React, { useState } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Col, Row } from "reactstrap"
import { SearchInput } from "components"

export const TableFilter = ({ onSearch }) => {
  const { t } = useTranslation()

  const [searchInputValue, setSearchInputValue] = useState("")

  const handleInputChange = value => {
    setSearchInputValue(value)
  }
  return (
    <Row>
      <Col>
        <SearchInput
          value={searchInputValue}
          onInputChange={handleInputChange}
          onSearch={onSearch}
          placeholder={t("search-user")}
          autoComplete={"off"}
          minLimit={3}
        />
      </Col>
    </Row>
  )
}

TableFilter.propTypes = {
  onSearch: PropTypes.func,
}
